import React, { useState } from "react";
import { StyledText } from "../assets/typography/typography";
import { colors } from "./colors";
import { ExternalLinkWrapper } from "./ExternalLinkWrapper";

interface ExternalLinkButtonProps
  extends React.HTMLAttributes<HTMLAnchorElement> {
  href: string;
  text: string;
  icon?: React.ReactNode;
  backgroundColor: string;
  hoverColor: string;
  textColor: string;
  width?: string;
}

export const ExternalLinkButton = ({
  href,
  text,
  icon,
  backgroundColor,
  hoverColor,
  textColor,
  width,
  ...rest
}: ExternalLinkButtonProps) => {
  const [bgColor, setBgColor] = useState<string>(backgroundColor);
  return (
    <ExternalLinkWrapper
      className="d-flex flex-row align-items-center justify-content-center px-4 py-3 bodyTextRegular mb-0 b-4px text-center"
      href={href}
      style={{
        backgroundColor: bgColor,
        textDecoration: "none",
        color: colors.textPrimary,
        gap: "8px",
        height: "fit-content",
        width: width ?? "100%",
        textWrap: "nowrap",
      }}
      onMouseEnter={() => {
        setBgColor(hoverColor);
      }}
      onMouseLeave={() => {
        setBgColor(backgroundColor);
      }}
      {...rest}
    >
      {icon && (
        <StyledText color={textColor} className="bodyTextSemibold mb-0">
          {icon}
        </StyledText>
      )}
      <StyledText color={textColor} className="bodyTextSemibold mb-0">
        {text}
      </StyledText>
    </ExternalLinkWrapper>
  );
};
